module.exports = __webpack_public_path__ + "img/pupr.48eeb80b.svg";